import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { UpdateUserData } from '../../services/partner.service';
import { useNavigate } from 'react-router-dom';
import {
    fetchPartnerOptions,
    updateAdminPartnerMapping,
} from '../../services/partner.service';
import TokenService from '../../services/token.service';
import AppModal from '../appModal.component';
import MessageContainer from '../message.component';
import WithLogin from '../withLogin.component';

const SwtichPartner = props => {
    const [show, setModalShow] = useState(props.open);
    const [loading, setLoading] = useState(false);
    const [partnerList, setPartnerList] = useState([]);
    const [message, setMessage] = useState({});
    const navigate = useNavigate();

    const handleModalClose = () => {
        setModalShow(false);
        props.setopenAddForm(false);
    };

    const handleSwitchPartner = data => {
        const partner_id = TokenService.getLocalPartnerId();
        if (partner_id === data.partner_id)
            return
        updateAdminPartnerMapping({ partner_id: data.partner_id })
            .then(async (response) => {
                const data = await UpdateUserData()
                localStorage.setItem(
                    'user_me',
                    JSON.stringify(data),
                );
                navigate('/accounts/');
                window.location.reload();
                handleModalClose();
            })
            .catch(err => { console.log(err) });
    };

    const getPartnerOptions = async () => {
        setLoading(true);
        try {
            const partnerList = await fetchPartnerOptions();
            setPartnerList(partnerList);
        } catch (error) {
            setMessage({
                detail: 'An error has occurrded during partners loading.',
                type: 'Error',
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        getPartnerOptions();
        const partner_id = TokenService.getLocalPartnerId();
        setValue('partner_id', partner_id);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            partner_id: '',
        },
    });

    return (
        <AppModal
            size="md"
            show={show}
            onHide={handleModalClose}
            backdrop="static"
            modalTitle="Swtich Partner">
            <div className="formView">
                {message && <MessageContainer message={message} />}
                <form
                    className="row g-2"
                    onSubmit={handleSubmit(handleSwitchPartner)}>
                    <div className="col-12">
                        <label htmlFor="partner_id">Select Partner</label>
                        <select
                            className={
                                errors?.partner_id
                                    ? 'form-control is-invalid'
                                    : 'form-control'
                            }
                            id="partner_id"
                            {...register('partner_id', { required: true })}>
                            {partnerList.map(partner => (
                                <option value={partner.id} key={partner.id}>
                                    {partner.name}(id: {partner.id})
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}>
                            {loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </AppModal>
    );
};

export default WithLogin(SwtichPartner);
